import { UserService } from 'src/app/angularJS/services/user/user.service';

/**
 * Handles all actions for an operator
 */
export class OperatorFormController {
  private static $inject = ['$translate', 'userService', '$scope'];

  public currentLocale: string;
  public schemes: Array<InterACT.Interfaces.Schemes.Scheme>;
  public inEdit: boolean;
  public regexPattern: string;
  public model: InterACT.Interfaces.TransportOperators.TransportOperator;
  public name: string;
  public tradingName: string;
  public externalReferences: Array<InterACT.Interfaces.ITransportOperatorExternalReference>;

  constructor(
    private $translate: ng.translate.ITranslateService,
    private userService: UserService,
    $scope
  ) {
    // tslint:disable-next-line: forin
    for (const propertyName in $scope.vm) {
      this[propertyName] = $scope.vm[propertyName];
    }

    this.activate();
  }

  /**
   * Retrieves the class for the section dependent on it being the last of external reference section
   * @param index the index of the section to check
   * @return the class final-section if the sections is the last
   */
  public getReferenceSectionClass = (index: number) => {
    return this.isLastReference(index) ? 'final-section' : '';
  }

  /**
   * Determines whether the index entered is the last reference
   * @param index the index to check
   * @return true if the index is the last reference in externalReferences
   */
  public isLastReference = (index: number) => {
    return index === this.externalReferences.length - 1;
  }

  /**
   * Gets the heading for the internal information section whose index is entered
   * @param index the index in the array of externalReferences on the model of this header
   * @returns the constructed header for the section
   */
  public getInternalInformationHeader = (index: number) => {
    const headingtitle = this.$translate.instant('HEADING.INTERNAL_INFORMATION');
    return this.externalReferences.length === 1
      ? headingtitle
      : `${headingtitle} ${index + 1}`;
  }

  /**
   * Determines whether the scheme entered has already been used in another reference
   * @param scheme the scheme to check
   * @returns true if the scheme is already in a reference
   */
  public isSchemeSelected = (scheme: InterACT.Interfaces.Schemes.Scheme) => {
    return _.some(this.externalReferences, (reference) => {
      return reference.scheme ? reference.scheme.id === scheme.id : false;
    });
  }

  /**
   * Determines whether all available user schemes have been used
   * @returns true if all schemes exist in external references
   */
  public allSchemesUsed = () => {
    return _.every(this.userService.schemes, (scheme) => this.isSchemeSelected(scheme));
  }

  /**
   * Pushes an empty object to the externalReferences array used by the view to show a new row of fields for data enrty
   */
  public addScheme = () => {
    this.externalReferences.push({});
  }

  /**
   * Removes the given object from the externalReferences array
   * @param reference The external reference object to be removed
   */
  public removeScheme = (reference: InterACT.Interfaces.ITransportOperatorExternalReference) => {
    if (this.externalReferences.length > 1) {
      const index = this.externalReferences.indexOf(reference);
      this.externalReferences.splice(index, 1);
    }
  }

  /**
   * Sets any default variables on the controller
   */
  private activate = () => {
    this.inEdit = this.name ? true : false;
    this.currentLocale = this.$translate.use();
    this.schemes = this.userService.schemes;
    this.regexPattern = '[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]?( |)[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}';

    if (!this.model.fields) {
      this.model.fields = {};
    }
    if (!this.externalReferences.length) {
      this.addScheme();
    }
  }
}